import WebClient from '@services/utils/WebClient';

import { type ICreateFolderInputData } from './dtos/createFolder/InputData';
import { type IDeleteFolderInputData } from './dtos/deleteFolder/InputData';
import { type IMoveFolderInputData } from './dtos/moveFolder/InputData';
import { type IUpdateFolderInputData } from './dtos/updateFolder/InputData';
import { type IFolderRepository } from './IFolderRepository';

interface ICreateBody {
  color: string;
  parent_folder_id: string | null;
  title: string;
}

interface IMoveBody {
  parent_folder_id: string | null;
}

interface IUpdateBody {
  color: string;
  title: string;
}

class FolderService implements IFolderRepository {
  public async create(inputData: ICreateFolderInputData): Promise<void> {
    await WebClient.post<void, ICreateBody>({
      path: 'storages/folders',
      body: {
        color: inputData.color,
        title: inputData.name,
        parent_folder_id: inputData.folderId,
      },
    });
  }

  public async delete(inputData: IDeleteFolderInputData): Promise<void> {
    await WebClient.delete<void>({
      path: `storages/folders/${inputData.id}`,
    });
  }

  public async move(inputData: IMoveFolderInputData): Promise<void> {
    await WebClient.patch<unknown, IMoveBody>({
      path: `storages/folders/${inputData.id}/move`,
      body: {
        parent_folder_id: inputData.folderIdDestination,
      },
      params: {
        id: inputData.id,
      },
    });
  }

  public async update(inputData: IUpdateFolderInputData): Promise<void> {
    await WebClient.put<void, IUpdateBody>({
      path: `storages/folders/${inputData.id}`,
      body: {
        color: inputData.color,
        title: inputData.title,
      },
    });
  }
}

export default new FolderService();
